import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { deleteInArray, deleteInProperties, errorCatch, foreachInProperties, GET, GetMetaProperties, Model, POST, QueryDetail, QueryOrder, QueryParam, SetMetaProperties, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import MDEditor, { } from "@uiw/react-md-editor";
import ModernUserSelection from '../../components/ModernUserSelection';
import User from '../../../common/User';
import EmojiTextArea from '../../../common/EmojiTextArea';
import { useCallback } from 'react';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        // display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})


export default function FederationadministratorPostsTipipostov(props) {
    const classes = useStyles();
    const { auth } = props;

    const filters = () => [
        {
            name: "nazvanie",
            sort: true,
            filter: true,
        },
        // {
        //     name: "obyazatelnost",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "obyazatelnost",
            sort: true,
            filter: true,
            // label: "Связан с телеграм",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    data: [
                        { ID: 1, name: "Да" },
                        { ID: 2, name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == 1) {
                    return QueryParam("w-" + key, "true")
                } else if (value == 2) {
                    return QueryParam("w-" + key, "false")
                }
                return ""
            },
            // queryComparer: (value, item) => {
            //     if (value == 1) {
            //         return "nnu"
            //     } else if (value == 2) {
            //         return "nu"
            //     }
            //     return ""
            // }
        },
        {
            name: "prioritet",
            sort: true,
            filter: true,
        },
        {
            name: "kommentarii",
            sort: true,
            filter: true,
        }
        // {
        //     name: "user.lastname",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "user.firstname",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "user.patronymic",
        //     sort: true,
        //     filter: true,
        // },

        // {
        //     name: "user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Телефон",
        //     name: "user.phone",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "user.gender",
        //     sort: true,
        //     filter: true,
        //     display: (o) => o.name,
        // },
        // {
        //     label: "Дата создания",
        //     name: "user.createdAt",
        //     type: "date",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Тип счета",
        //     name: "akkauntType",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryOrder("code", "ASC"),
        //         // QueryParam("w-in-id", "2,9")
        //         QueryParam("w-neq-id", "7")
        //     ],
        //     display: (o) => o.opisanie,
        //     sort: true,
        //     filter: true,
        //     // filtered: [2],
        // },
        // {
        //     label: "Баланс счета",
        //     name: "ostatok",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Номер счета",
        //     name: "nomerAkkaunta",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
        //     name: "accountInfo.vladelets",
        //     // queryComparer:"swsim", // sim, wsim, swsim
        //     sort: true,
        //     filter: true,
        // },
    ];

    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => {
        return (<div key={item.ID || idx} style={{ width: "100%" }}>
            <div className={classes.item} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {/* <User item={item?.user} noborder={true} /> */}
                <div className='bg bg-grey' style={{ flex: "0 0 50px", fontSize: "12px" }}>{item?.prioritet}</div>
                <div style={{ flex: "1 1 auto" }}>{item?.nazvanie}</div>
            </div>
        </div>)
    }

    const EmojiField = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<EmojiTextArea
            rows={25}
            auth={auth}
            // item={item}
            value={value}
            onChange={onChange}
            onAfterChange={onAfterChange}
        />)
    }, [auth])


    // "/api/tipipostov/create"
    // "/api/tipipostov/update"
    // "/api/tipipostov/delete/{id}"
    // "/api/tipipostov/list"
    // "/api/tipipostov/byid/{id}"

    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])
        // if (object && obj.type == "object") {
        //     p = updateInPropertiesUUID(p, {
        //         uuid: "object-owner-description",
        //         type: "func",
        //         render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
        //     }, true)
        // }
        // if (contextObject && obj.type == "object" && field) {
        //     let fName = _.get(field, "relation.reference.property");
        //     let o = obj?.properties?.find(e => e.name == fName)
        //     if (o) {
        //         let oObj = _.get(o, "relation.reference.object");
        //         let oMeta = meta[oObj];
        //         p = updateInPropertiesUUID(p, {
        //             uuid: "object-context-description",
        //             type: "func",
        //             render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
        //                 {(oMeta) && <div style={{
        //                     fontSize: "10px",
        //                     color: "rgb(106, 106, 106)",
        //                     lineHeight: "10px",
        //                     fontStyle: "italic"
        //                 }}>{o?.label} ({oMeta?.label})</div>}
        //                 <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
        //                 <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
        //             </div>)
        //         }, true)
        //     }
        // }
        // if (funcs) {
        //     for (let i = 0; i < funcs.length; i++) {
        //         const f = funcs[i];
        //         p = f(p);
        //     }
        // }

        // p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
        //     type: "text"
        // })
        // p = foreachInProperties(p, n => (n.type == "object" && n.name == "TipDlyaTreka"), {
        //     relation: {
        //         displayString: (item) => {
        //             return item?.nazvanie
        //         },
        //         display: (item) => {
        //             return (
        //                 <div>{item?.nazvanie}</div>
        //             )
        //         },
        //         reference: { object: "TipiDlyaTrekov", property: "ID" },
        //         type: "many-one",
        //     },
        //     queryFilter: [
        //         QueryDetail("collection"),
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        // })
        // p = foreachInProperties(p, n => (n.type == "object" && n.name == "RaspredeleniePoKategoriyamTrek"), (n) => {
        //     return ({
        //         queryFilter: [
        //             QueryDetail("collection"),
        //             // QueryOrder("sozdatel.familiya", "ASC"),
        //         ],
        //         relation: {
        //             ...n?.relation,
        //             uiFilter: () => [],
        //             displayString: (item) => {
        //                 return `${item?.distsiplina?.nazvanie} - ${item?.kategoriya?.nazvanie} Тур: ${item?.tur?.nazvanie}, Порядковый номер в туре: ${item?.poryadkoviiNomerVTure}, Сложность: ${item?.slozhnost}`
        //             },
        //             display: (item) => {
        //                 return (
        //                     <div>
        //                         <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>
        //                             {item?.distsiplina?.nazvanie} - {item?.kategoriya?.nazvanie}
        //                         </div>
        //                         <div>Тур: {item?.tur?.name}, Порядковый номер в туре: {item?.poryadkoviiNomerVTure}</div>
        //                         <div style={{ color: "rgba(0,0,0,0.65)" }}>Сложность: {item?.slozhnost}</div>
        //                     </div>
        //                 )
        //             },
        //         },
        //     })
        // })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "ParametriTipovPostovTipPosta"), (n) => {
            return ({
                relation: {
                    ...n?.relation,
                    uiFilter: () => [],
                    displayString: (item) => {
                        return `${item?.key}: ${item?.tipParametra?.nazvanie}`
                    },
                    display: (item) => {
                        return (<div style={{display:"flex", gap:"10px"}}>
                            <div style={{fontWeight:"bold"}}>{item?.key}</div>
                            <div>{item?.tipParametra?.nazvanie}</div>
                        </div>)
                    },
                },
            })
        })
        p = foreachInProperties(p, n => {
            // console.log(n);
            
            return (n.type == "object" && n.name == "TipParametra")}, (n) => {
            return ({
                relation: {
                    ...n?.relation,
                    uiFilter: () => [],
                    displayString: (item) => {
                        return `${item?.key}: ${item?.nazvanie}`
                    },
                    display: (item) => {
                        return (<div>
                            <div>{item?.nazvanie}</div>
                        </div>)
                    },
                },
            })
        })

        // p = foreachInProperties(p, n => (n.type == "object" && n.name == "Sozdatel"), (n) => ({
        //     queryFilter: [
        //         QueryDetail("collection"),
        //         QueryOrder("familiya", "ASC"),
        //     ],
        //     relation: {
        //         ...n?.relation,
        //         displayString: (item) => {
        //             return `${item?.familiya} ${item?.imya}${(item?.psevdonim) ? " (" + item?.psevdonim + ")" : ""}`
        //         },
        //         display: (item) => {
        //             return (
        //                 <div>
        //                     <div>{item?.familiya} {item?.imya}</div>
        //                     {/* <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.psevdonim}</div> */}
        //                 </div>
        //             )
        //         },
        //     },
        //     dropdownActions: () => [
        //         {
        //             title: "Добавить создателя трека",
        //             form: Model,
        //             meta: [
        //                 {
        //                     label: "Фамилия",
        //                     name: "familiya",
        //                     type: "string",
        //                 },
        //                 {
        //                     label: "Имя",
        //                     name: "imya",
        //                     type: "string",
        //                 },
        //                 {
        //                     label: "Псевдоним",
        //                     name: "psevdonim",
        //                     type: "string",
        //                 },
        //                 {
        //                     label: "Страна",
        //                     name: "strana",
        //                     type: "object",
        //                     relation: {
        //                         displayString: (item) => {
        //                             return item?.name
        //                         },
        //                         display: (item) => {
        //                             return (
        //                                 <div>
        //                                     <div>{item?.name}</div>
        //                                     {/* <div style={{fontSize:"12px", color:"rgba(0,0,0,0.65)"}}>{item?.code}</div> */}
        //                                 </div>
        //                             )
        //                         },
        //                         reference: { object: "Countries", property: "ID" },
        //                         type: "many-one",
        //                     },
        //                     queryFilter: [
        //                         // QueryDetail("model"),
        //                         QueryOrder("name", "ASC")
        //                     ],
        //                 },
        //             ],
        //             action: (values, unlock, close, { collection, setCollection, apply }) => {
        //                 CREATE(auth, 'BazaSozdateleiTrekov', { ...values },
        //                     ({ data }) => {
        //                         setCollection(updateInArray(collection, data));
        //                         if (apply) {
        //                             apply(data);
        //                         }
        //                         close();
        //                     },
        //                     (err) => errorCatch(err, unlock)
        //                 );
        //             },
        //         },
        //     ]
        // }))

        return SetMetaProperties(obj, p)
    }


    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingBottom: "15px", fontSize: "18px" }}>Типы постов</div>
                </div>
                <CollectionServer
                    auth={auth}
                    name={"TipiPostov"}
                    // queryDetail={"collection"}
                    source={"/api/tipipostov/list"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    // title="Создатели постов"
                    render={render}

                    linksModelActions={"inline"}
                    scheme={[
                        "ParametriTipovPostovTipPosta",
                    ]}
                    // collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                    // }}
                    // modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                    // }}

                    // "/api/parametritipovpostov/create" POST
                    // "/api/parametritipovpostov/update" POST
                    // "/api/parametritipovpostov/delete/{id}"
                    // "/api/parametritipovpostov/list"
                    // "/api/parametritipovpostov/byid/{id}"

                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                        // console.log(name, field, fieldName);
                        if (name == 'TipiPostov') {
                            return [{
                                auth: auth,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, `/api/tipipostov/create`, values,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data, true));
                                            close();
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                title: "Создать",
                                modal: {
                                    title: "Создание типа постов",
                                    width: "650px"
                                },
                                // form: ModernUserSelection,
                                form: Model,
                                meta: [
                                    {
                                        label: "Название",
                                        name: "nazvanie",
                                        type: "string",
                                    },
                                    {
                                        label: "Обязательность",
                                        name: "obyazatelnost",
                                        type: "bool",
                                    },
                                    {
                                        label: "Приоритет",
                                        name: "prioritet",
                                        type: "int",
                                    },
                                    {
                                        label: "Комментарий",
                                        name: "kommentarii",
                                        type: "func",
                                        render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                                            return (<MDEditor
                                                data-color-mode="light"
                                                value={value} onChange={onChange}
                                                preview={"edit"}
                                                overflow={false}
                                            />)
                                        }
                                    },
                                    // {
                                    //     label: "Пользователь",
                                    //     name: "user",
                                    //     type: "object",
                                    //     relation: {
                                    //         display: (item) => {
                                    //             return item.firstname
                                    //         },
                                    //         reference: { object: "User", property: "ID" },
                                    //         type: "many-one",
                                    //     },
                                    //     queryFilter: [
                                    //         QueryDetail("model"),
                                    //         QueryOrder("lastname", "ASC")
                                    //     ],
                                    // },
                                    {
                                        label: "Тип ссылки для сайта",
                                        name: "tipSsilkiDlyaSaita",
                                        type: "object",
                                        relation: {
                                            display: (item) => {
                                                return item.opisanie
                                            },
                                            reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryOrder("ID", "ASC")
                                        ]
                                    },
                                    {
                                        label: "Текст ссылки на сайте",
                                        name: "tekstSsilkiNaSaite",
                                        type: "string"
                                    },
                                    {
                                        label: "Текст поста",
                                        name: "tekstPosta",
                                        type: "func",
                                        render: EmojiField,
                                    },
                                ],
                            }]
                        } else if (name == "ParametriTipovPostov") {
                            // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }));
                            return [{
                                auth: auth,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    // console.log(contextObject);
                                    
                                    POST(auth, `/api/parametritipovpostov/create`, {...values, tipPostaID: contextObject?.ID},
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data, true));
                                            close();
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                title: "Создать",
                                modal: {
                                    title: "Создание параметра",
                                    width: "450px"
                                },
                                form: Model,
                                meta: cleanProperties(mobject, { name, field, fieldName, contextObject }),
                            }]
                        }
                    }}
                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                        // console.log(name, field, fieldName);
                        if (name == 'TipiPostov') {
                            return [
                                {
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/tipipostov/update`, { ...values, ID: item?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data, true));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Изменить",
                                    modal: {
                                        title: "Изменение типа постов",
                                        width: "650px"
                                    },
                                    // links: "inline",
                                    // scheme: [
                                    //     "ParametriTipovPostovTipPosta",
                                    // ],
                                    form: Model,
                                    meta: [
                                        {
                                            label: "Название",
                                            name: "nazvanie",
                                            type: "string",
                                        },
                                        {
                                            label: "Обязательность",
                                            name: "obyazatelnost",
                                            type: "bool",
                                        },
                                        {
                                            label: "Приоритет",
                                            name: "prioritet",
                                            type: "int",
                                        },
                                        {
                                            label: "Комментарий",
                                            name: "kommentarii",
                                            type: "func",
                                            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                                                return (<MDEditor
                                                    data-color-mode="light"
                                                    value={value} onChange={onChange}
                                                    preview={"edit"}
                                                    overflow={false}
                                                />)
                                            }
                                        },
                                        {
                                            label: "Тип ссылки для сайта",
                                            name: "tipSsilkiDlyaSaita",
                                            type: "object",
                                            relation: {
                                                display: (item) => {
                                                    return item.opisanie
                                                },
                                                reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                                type: "many-one",
                                            },
                                            queryFilter: [
                                                QueryOrder("ID", "ASC")
                                            ]
                                        },
                                        {
                                            label: "Текст ссылки на сайте",
                                            name: "tekstSsilkiNaSaite",
                                            type: "string"
                                        },
                                        {
                                            label: "Текст поста",
                                            name: "tekstPosta",
                                            type: "func",
                                            render: EmojiField,
                                        },

                                        {
                                            label: "Параметры поста",
                                            name: "ParametriTipovPostovTipPosta",
                                            type: "object",
                                            relation: {
                                                display: (item) => {
                                                    return (<div style={{display:"flex", gap:"10px"}}>
                                                        <div style={{fontWeight:"bold"}}>{item?.key}</div>
                                                        <div>{item?.tipParametra?.nazvanie}</div>
                                                    </div>)
                                                },
                                                reference: { object: "ParametriTipovPostov", property: "TipPosta", source: "/api/parametritipovpostov/list" },
                                                type: "one-many",
                                            },
                                            queryFilter: [
                                                QueryOrder("key", "ASC")
                                            ]
                                        },
                                    ],
                                },
                                {
                                    auth: auth,
                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        confirmKey({
                                            pass: '123',
                                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить тип поста</span>,
                                            icon: undefined,
                                            content: <div>
                                                <div>Вы действительно хотите удалить тип поста?</div>
                                                <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.nazvanie} </div>
                                            </div>,
                                            okText: 'Удалить',
                                            cancelText: 'Отмена',
                                            onOk() {
                                                return new Promise((resolve, reject) => {
                                                    GET(auth, '/api/tipipostov/delete/' + item.ID,
                                                        ({ data }) => {
                                                            setCollection(deleteInArray(collection, item));
                                                            resolve(data);
                                                        }, (err) => errorCatch(err, reject));
                                                }).catch(() => { });
                                            },
                                            onCancel() {
                                            },
                                        })
                                    }
                                }
                            ]
                        } else if (name == "ParametriTipovPostov") {
                            // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }));
                            return [
                                {
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/parametritipovpostov/update`, { ...values, ID: item?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data, true));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Изменить",
                                    modal: {
                                        title: "Изменение параметра",
                                        width: "450px"
                                    },
                                    form: Model,
                                    meta: cleanProperties(mobject, { name, field, fieldName, contextObject })
                                },
                                {
                                    auth: auth,
                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        confirmKey({
                                            pass: '123',
                                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить параметр</span>,
                                            icon: undefined,
                                            content: <div>
                                                <div>Вы действительно хотите удалить параметр?</div>
                                                <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.nazvanie} </div>
                                            </div>,
                                            okText: 'Удалить',
                                            cancelText: 'Отмена',
                                            onOk() {
                                                return new Promise((resolve, reject) => {
                                                    GET(auth, '/api/parametritipovpostov/delete/' + item.ID,
                                                        ({ data }) => {
                                                            setCollection(deleteInArray(collection, item));
                                                            resolve(data);
                                                        }, (err) => errorCatch(err, reject));
                                                }).catch(() => { });
                                            },
                                            onCancel() {
                                            },
                                        })
                                    }
                                }
                            ]
                        }
                    }}
                />
            </div>
        </PageLayout>

    );
}
